import type { pageType } from "@/common/apis/permission/type"
import { GetPermission } from "@/common/apis/permission"
import { pinia } from "@/pinia"
import { resetRouter } from "@/router"
import { getCurrentUserApi } from "@@/apis/users"
import { setToken as _setToken, getToken, removeToken } from "@@/utils/cache/cookies"
import { useSettingsStore } from "./settings"
import { useTagsViewStore } from "./tags-view"

export const useUserStore = defineStore("user", () => {
  const token = ref<string>(getToken() || "")
  type AllType = {
    [key in pageType]: { action: string, name: string }[]
  }
  const roles = ref<{ page: pageType[], All: AllType | null, Action: string[] }>({
    page: [],
    All: null,
    Action: []
  })
  const username = ref<string>("")
  const userInfo = ref({
    username: "",
    nick: "",
    head: "",
    phone: "",
    pushkey: ""
  })

  const tagsViewStore = useTagsViewStore()
  const settingsStore = useSettingsStore()

  // 设置 Token
  const setToken = (value: string) => {
    _setToken(value)
    token.value = value
  }

  // 获取用户详情
  const getInfo = async () => {
    const { data } = await getCurrentUserApi()// 用户信息
    const { data: PermissionData } = await GetPermission()// 用户权限

    const role_page = Object.keys(PermissionData) as pageType[]
    if (role_page.length !== 0) {
      roles.value.page = role_page
    } else {
      roles.value.page = ["DEFAULT_ROLE"]
    }
    role_page.forEach((item) => {
      const data = PermissionData[item]
      if (data) {
        data.forEach((i) => {
          roles.value.Action.push(`${item}_${i.action}`)
        })
      }
    })

    username.value = data.nick ?? data.username
    userInfo.value = data
    userInfo.value.head = `${data.head}?t=${new Date().getTime()}`
  }

  // 模拟角色变化
  const changeRoles = (role: string) => {
    const newToken = `token-${role}`
    token.value = newToken
    _setToken(newToken)
    // 用刷新页面代替重新登录
    location.reload()
  }

  // 登出
  const logout = () => {
    removeToken()
    token.value = ""
    roles.value = {
      page: [],
      All: null,
      Action: []
    }
    resetRouter()
    resetTagsView()
  }

  // 重置 Token
  const resetToken = () => {
    removeToken()
    token.value = ""
    roles.value = {
      page: [],
      Action: [],
      All: null
    }
  }

  // 重置 Visited Views 和 Cached Views
  const resetTagsView = () => {
    if (!settingsStore.cacheTagsView) {
      tagsViewStore.delAllVisitedViews()
      tagsViewStore.delAllCachedViews()
    }
  }

  // 重新 获取头像
  const ResetHeadImg = (res: string) => {
    userInfo.value.head = res
  }

  return { ResetHeadImg, token, roles, username, userInfo, setToken, getInfo, changeRoles, logout, resetToken }
})

/**
 * @description 在 SPA 应用中可用于在 pinia 实例被激活前使用 store
 * @description 在 SSR 应用中可用于在 setup 外使用 store
 */
export function useUserStoreOutside() {
  return useUserStore(pinia)
}
